import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Transition as ReactTransition } from 'react-transition-group';
import Velocity from 'velocity-animate';

import { isCookieWallHidden } from '@wetransfer/transfer/component/consent-manager/flags';
import { ConnectedConsentWall } from '@wetransfer/transfer/component/welcome/consent-wall';
import { getCurrentPathname } from '@wetransfer/transfer/modules/url';
import Store from '@wetransfer/transfer/store';
import Actions from '@wetransfer/transfer/store/action';

import './welcome.scss';

export const STEP_TERMS_AND_CONDITIONS = 'STEP_TERMS_AND_CONDITIONS';

export const STEP_COOKIES = 'STEP_COOKIES';
const STEPS = [STEP_TERMS_AND_CONDITIONS, STEP_COOKIES];

const onExit = (component) => {
  Velocity(
    component,
    {
      scale: '1.3',
      opacity: 0,
    },
    { duration: 300 }
  );
};

export const isUrlPricingPage = () => {
  const pathname = getCurrentPathname();
  const isPricingPage = pathname === '/pricing';

  return isPricingPage;
};

export const Welcome = ({
  step,
  in: inProp,
  cookieWallVariation,
  isPanelOpen,
}) => {
  const isOverlappingAllContainers = isPanelOpen;

  // When a panel is open this will close it
  // when the user clicks on the main window
  const closePanel = () => {
    Store.dispatch(Actions.Consent.setUIVisible(false));
  };

  const className = classnames('welcome', {
    'welcome--consent-wall': step === STEP_COOKIES,
  });

  const backgroundImageClass = classnames(
    'welcome__background',
    cookieWallVariation.backgroundImage,
    {
      'welcome__background--panel-open': isOverlappingAllContainers,
    }
  );

  const coverImageClass = classnames(
    'welcome__cover',
    cookieWallVariation.coverClass
  );

  const containerClass = classnames('welcome__container', {
    'welcome__container--panel-open': isOverlappingAllContainers,
  });

  if (isUrlPricingPage() && isCookieWallHidden()) {
    return <></>;
  }

  return (
    <div className={className}>
      <ReactTransition
        in={inProp}
        timeout={{ in: 0, exit: 300 }}
        unmountOnExit={true}
        onExit={onExit}
      >
        <div className={backgroundImageClass} />
      </ReactTransition>
      <ReactTransition
        in={inProp}
        timeout={{ in: 0, exit: 300 }}
        unmountOnExit={true}
        onExit={onExit}
      >
        <div className={containerClass}>
          <div className={coverImageClass} />
          <div className="welcome__content-wrapper">
            {step === STEP_COOKIES && (
              <ConnectedConsentWall
                cookieWallVariation={cookieWallVariation}
                closePanel={closePanel}
              />
            )}
            <div className="welcome__cookie_wall_name">
              {cookieWallVariation.artistName}
            </div>
          </div>
        </div>
      </ReactTransition>
    </div>
  );
};

Welcome.propTypes = {
  step: PropTypes.oneOf(STEPS),
  in: PropTypes.bool,
  cookieWallVariation: PropTypes.object.isRequired,
  isPanelOpen: PropTypes.bool,
};

Welcome.defaultProps = {
  step: STEPS[0],
};

const mapStateToProps = ({ route }) => ({
  isPanelOpen: route.isPanelOpen,
  path: route.path,
});

const ConnectedWelcome = connect(mapStateToProps)(Welcome);

export default ConnectedWelcome;
